export default "__VITE_ASSET__DFb77IV6__"